import { Redirect } from "react-router";
import { ERoute } from "../../helpers/Routes";
import React from "react";
import { useAuthMode } from "../rx/useAuthMode";
import { SummaryScreen } from "./Summary";
export var AuthIndex = (function () {
    if (useAuthMode() !== "summary")
        return React.createElement(Redirect, { to: ERoute.USER_BOOKINGS });
    return React.createElement(SummaryScreen, null);
});
